import { makeStyles, withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import bg from "../assets/images/bg_small.jpg";

export const HamButton = withStyles((theme) => ({
  root: {
    float: "right",
    margin: "0 0 0 auto",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "none",
    },
  },
}))(IconButton);

export const useStyles = makeStyles((theme) => ({
  navWrapper: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    zIndex: 100,
    backgroundImage: `linear-gradient(to top, ${theme.palette.darkPurple} 0%, ${theme.palette.darkPurple} 100%), url(${bg})`,
    backgroundBlendMode: "multiply",
    height: theme.dimensions.nav.menuHeight.md,
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      backgroundImage: `linear-gradient(to top, ${theme.palette.darkPurple} 0%, ${theme.palette.darkPurple} 100%), url(${bg})`,
      backgroundBlendMode: "multiply",
      height: theme.dimensions.nav.menuHeight.md,
    },
  },
  navCenter: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "5rem",
    maxWidth: theme.limits.max,
    justifySelf: "center",
    alignSelf: "center",
    justifyContent: "flex-start",
  },

  navLimit: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "5rem",
    maxWidth: theme.limits.lg,
    justifyContent: "center",
  },
  logo_link: {
    "&:focus": {
      outline: "none",
    },
    "&:focus $takisLogo": {
      backgroundColor: theme.palette.purple,
    },
    "&:active $takisLogo": {
      backgroundColor: theme.palette.purple,
    },
  },
  takisLogo: {
    position: "absolute",
    zIndex: 100,
    left: "calc(50vw - 4.25rem)",
    top: 0,
    ...theme.dimensions.nav.logo.sm,
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      position: "relative",
      margin: "0 0 0 2.25rem",
      left: 0,
      ...theme.dimensions.nav.logo.md,
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      margin: "0 0 0 2.063rem",
      ...theme.dimensions.nav.logo.md,
    },
  },
  nav_button: {
    zIndex: 100,
    right: "1rem",
    float: "right",
    position: "absolute",
    margin: "auto 0 0 auto",
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    top: "1rem",
    paddingTop: "1em",
    paddingBottom: "1em",
    height: "2.5em",
    "&:focus": {
      backgroundColor: theme.palette.purple,
      borderRadius: 0
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "none",
    },
  },
  barsIcon: {
    color: theme.palette.yellow,
    width: "2.5rem",
    height: "2.5rem",
  },
  navbar: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
    top: 0,
    marginTop: "5rem",
    width: "100%",
    height: 0,
    backgroundImage: `linear-gradient(to top, #32094a 0%, #32094a 100%), url(${bg})`,
    backgroundBlendMode: "multiply",
    transition: "height 0.6s",
    overflow: "hidden",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      marginTop: 0,
      backgroundImage: "unset",
      backgroundColor: "transparent",
      position: "unset",
      overflow: "unset",
      margin: "0 0 0 2rem",
      top: 0,
      height: "100%",
      width: "fit-content",
      flexDirection: "row",
      transition: "none",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      margin: "0 0 0 4rem",
    },
  },
  screen_cover: {
    display: "flex",
    position: "absolute",
    top: 0,
    backgroundColor: "black",
    opacity: "0",
    marginTop: "5rem",
    width: "100%",
    height: "0",
    overflow: "hidden",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "none",
    },
  },
  screen_cover_on: {
    display: "flex",
    height: "calc(100vh - 5rem)",
    opacity: "0.5",
    transition: "opacity 0.5s",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "none",
    },
  },
  navbar_open: {
    backgroundColor: "unset",
    backgroundImage: `linear-gradient(to top, #5d0e8b -3%, #32094a 77%), url(${bg})`,
    transition: "height 0.6s",
    height: "calc(95vh - 5rem)",
    marginTop: "5rem",
    paddingBottom: "3.75rem",
    overflowY: "auto",
  },
  nav_options: {
    overflow: "visible",
    "&:first-child": {
      margin: "0.3rem 0 0 0",
    },
    margin: "1rem 0 0 0",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      "&:first-child": {
        margin: "0 0 0 -1rem",
      },
      margin: "0 0 0 0.5rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      "&:first-child": {
        margin: "0 0 0 -1rem",
      },
      margin: "0 0 0 3rem",
    },
  },
  listItemLink: {
    listStyle: "none",
    overflow: "visible",
    padding: 0,
    "&:first-child": {
      margin: "0.3rem 0 0 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      "&:first-child": {
        margin: "0 0 0 -1rem",
      },
      margin: "0 0 0 0.5rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      "&:first-child": {
        margin: "0 0 0 -1rem",
      },
      margin: "0 0 0 3rem",
    },
  },
  noUnderline: {
    textDecoration: "none !important"
  },
  menu_link: {
    border: "none",
    boxSizing: "border-box",
    color: theme.palette.white,
    fontFamily: "Veneer, Arial",
    textDecoration: "none",
    fontSize: theme.fontSizes.navLinks.sm,
    padding: "0.375rem 1rem !important",
    outline: "none !important",
    transition: "background-color 0.3s ease-out",
    "&:focus, &:active, &:focus-visible, &:focus-within , &:target": {
      backgroundColor: theme.palette.purple,
      outline: "none",
      border: "none",
      "&.isOpen" : {
        outline: "none",
        textDecoration: "underline",
      },
      "&.isClosed" : {
        outline: "none",
        border: "none",
      }
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      padding: "0.375rem 0.5rem",
      whiteSpace: "nowrap",
      fontSize: theme.fontSizes.navLinks.md,
      lineHeight: theme.fontSizes.navLinks.lg,
      outline: "none",
      "&:hover": {
        color: theme.palette.menuForeground,
        outline: "none",
      },
      "&:focus": {
        outline: "none",
        border: "none",
      }
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      padding: "0.375rem 1rem",
      whiteSpace: "nowrap",
      fontSize: theme.fontSizes.navLinks.lg,
      lineHeight: theme.fontSizes.navLinks.lg,
      outline: "none",
      "&:focus": {
        outline: "none",
        border: "none",
      }
    },
  },
  dropdown_manager: {
    position: "relative",
    height: "fit-content",
    display: "block",
    textAlign: "center",
    "& $menu_link": {
      width: "100%",
      color: theme.palette.white,
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      "&:focus": {
        backgroundColor: theme.palette.gridPurple,
      },
      height: theme.dimensions.nav.menuHeight.md,
      display: "flex",
      alignItems: "center",
    },
  },
  drop_link_active: {
    "& $menu_link": {
      backgroundColor: "unset",
      color: theme.palette.yellow,
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      "& $menu_link": {
        color: theme.palette.menuForeground,
        backgroundColor: theme.palette.menuBackground,
      },
      backgroundColor: theme.palette.menuBackground,
    },
  },
  dropDown_fixed: {
    // When is dropdown
    display: "block",
    position: "relative",
    top: "0",
    minWidth: "100%",
    backgroundColor: "transparent",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "block",
      position: "absolute",
      top: theme.dimensions.nav.menuHeight.md,
      backgroundColor: theme.palette.menuBackground,
    },
    "&.isProduct": {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: "unset",
      overflowY: "hidden",
      overflowX: "hidden",
      left: "0",
      backgroundColor: "transparent",
      transitionProperty: "max-height",
      transitionDuration: "0.15s",
      transitionTimingFunction: theme.transitions.easing.sharp,
      "&.isClosed": {
        maxHeight: 0
      },
      "&.isOpen": {
        maxHeight: "200vh"
      },
      // above mobile dropdown
      [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
        top: "100%",
        backgroundColor: theme.palette.menuBackground,
        flexDirection: "column",
        justifyContent: "flex-start",
        position: "absolute",
        left: "0",
        "&.isClosed": {
          maxHeight: 0
        },
        "&.isOpen": {
          maxHeight: "50vh",
          overflowY: "scroll",
        }
      },
      // at horizontal product max is horizontal
      [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
        flexDirection: "row",
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        top: theme.dimensions.nav.menuHeight.md,
        width: "100vw",
        boxSizing: "border-box",
        transitionTimingFunction: theme.transitions.easing.sharp,
        "&.isClosed": {
          maxHeight: 0
        },
        "&.isOpen": {
          overflowX: "scroll",
          maxHeight: "50vh",
          overflowY: "hidden",
        }
      },

    },
  },
  dropDown_content: {
    display: "none",
    position: "relative",
    minWidth: "70vw",
    backgroundColor: "transparent",
    top: 0,
    overflow: "visible",
    textAlign: "center",
    padding: 0,
    "&.isClosed": {
      maxHeight: 0,
      visibility: "hidden"
    },
    "&.isOpen": {
      maxHeight: "100vh"
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      maxWidth: "unset",
      display: "none",
      width: "max-content",
      position: "absolute",
      backgroundColor: theme.palette.menuBackground,
      minWidth: "100%",
      zIndex: 99,
      "&:after": {
        content: '""',
        position: "absolute",
        top: "100%",
        width: "100%",
        height: "0.438rem",
        backgroundColor: theme.palette.menuBackground,
        backgroundSize: "cover",
        clipPath: "polygon(0% 0%, 100% 0%, 0% 100%)",
        overflow: "hidden",
        left: 0,
        marginTop: "-1px"
      },
    },
    "&.isProduct": {
      position: "relative",
      backgroundColor: "transparent",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      justifyContent: "center",
      minWidth: "70vw",
      [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
        minWidth: "100%",
        position: "relative",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        top: "100%",
        flexDirection: "column",
        left: "3%",
        "&.isClosed": {
          maxHeight: 0
        },
        "&.isOpen": {
          display: "contents",
          maxHeight: "50vh"
        }
      },
      [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
        display: "flex",
        minWidth: "unset",
        flexDirection: "row",
        maxWidth: '100%',
        position: "relative",
        margin: "3rem 1rem",
        backgroundColor: theme.palette.menuBackground,
        zIndex: 99,
        "&.isClosed": {
          maxHeight: 0
        },
        "&.isOpen": {
          display: "flex",
          maxHeight: "50vh"
        }
      },

    },
  },
  dropDown_content_open: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      flexDirection: "row",
      // display: "contents",
    },
  },
  drop_options_image: {
    display: "none",
    transition: "all 0.15s ease-in",
    transformOrigin: "50% 90%",
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      display: "block",
    },
  },
  drop_options: {
    lineHeight: "unset",
    // padding: "0.75rem 1rem 0.75rem 1rem",
    display: "flex",
    textAlign: "center",
    fontFamily: "Veneer, Arial",
    letterSpacing: "0.018rem",
    textDecoration: "none",
    flexDirection: "column",
    fontSize: theme.fontSizes.navLinks.sm,
    transition: "all 0.15s ease-in",
    color: theme.palette.yellow,
    whiteSpace: "nowrap",
    "&:visited": {
      color: theme.palette.menuForeground,
    },
    "&:hover": {
      textDecoration: "underline",
      "& img": {
        transition: "all 0.15s ease-out",
        transform: "scale(1.2) translateY(-0.3rem)"
      }
    },
    "&:focus": {
      textDecoration: "underline",
      outline: "none",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      color: theme.palette.menuForeground,
      textAlign: "left",
      fontSize: theme.fontSizes.navLinks.md,
      justifyContent: "flex-start",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      color: theme.palette.menuForeground,
      justifyContent: "flex-end",
      fontSize: theme.fontSizes.navLinks.lg,
      alignItems: "center",
    },
  },
  listItemDropOptions: {
    lineHeight: "unset",
    padding: "0.75rem 1rem 0.75rem 1rem",
    display: "flex",
    textAlign: "center",
    listStyle: "none",
    flexDirection: "column",
    overflow: "visible",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      justifyContent: "flex-start",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      justifyContent: "flex-start",
      alignItems: "center",
    },
  },
  caretButton: {
    border: "none",
    background: "none",
    outline: "none",
    display: "inline-flex",
    justifyItems: "center",
    alignContent: "center",
    color: theme.palette.white,
    margin: "auto 0.8em auto -0.6em",
    padding: "0.2rem 0.4rem",
    "&:focus, &:hover": {
      color: theme.palette.yellow,
      backgroundColor: theme.palette.purple,
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      color: theme.palette.white,
      "&:focus, &:hover": {
        color: theme.palette.yellow,
        backgroundColor: theme.palette.purple,
      },
    },
  },
  caret_svg: {
    width: "1rem",
    height: "1em",
    fontSize: "1.5rem",
  },
  nav_rip: {
    display: "flex",
    width: "100%",
    marginTop: "auto",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "none",
    },
  },
  rip_margin: {
    height: "0.5rem",
  },
}));
